<mat-toolbar class="header">

  <div class="header__title">
    <button class="header__title-button" mat-mini-fab (click)="openMenu()">
      <mat-icon *ngIf="!isMenuOpened" class="header__title-button-icon">menu</mat-icon>
      <mat-icon *ngIf="isMenuOpened" class="header__title-button-icon">arrow_back</mat-icon>
    </button>
    <h6 class="header__title-text">Stock Check</h6>
  </div>

  <div class="header-toolbar">
    <!-- <app-notifications></app-notifications> -->
    <app-user [user]="user$ | async" (signOut)="signOut()"></app-user>
  </div>

</mat-toolbar>
